import api from 'services/api'
import {uploadFile as uploadFileUtil} from 'services/utils'

export const createInsurancePolicy = (newPolicy) =>
  api.post(`/contractor-policies`, newPolicy)

export const fetchInsurancePolicy = (policyId) =>
  api.get(`/contractor-policies/${policyId}`)

export const fetchContractorPolicies = (contractorId) =>
  api.get(`/contractors/${contractorId}/policies`)

export const updateInsurancePolicy = (policyId, updatedPolicy) =>
  api.put(`/contractor-policies/${policyId}`, updatedPolicy)

export const deleteInsurancePolicy = (policyId) =>
  api.delete(`/contractor-policies/${policyId}`)

export const uploadFile = (file, type) => uploadFileUtil(file, '/insurance-policy-files', [{name: 'type', value: type}])

export const getInsurancePolicyFile = (file) =>
  api.get(`/insurance-policy-files/${file.id}`,
    {responseType: 'blob'})
